// extracted by mini-css-extract-plugin
module.exports = {"DialogContent":"BuildButton_DialogContent__1AZ9D","CloseIcon":"BuildButton_CloseIcon__2cgFr"};